import { useState } from 'react';
import  ReactDOM from 'react-dom';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'

const GCWFaq = (props) => {
    return (
        <>

             {/* <section className="bannerAreaN whiteBackground BannerDeatils greyBackground position">
             <div className="detailsPageSection">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_1440,h_500/VantageFit/NewWebsite/pageBanner__compressed.png" alt="corporate wellness" className="img-responsive" width="1440" height="500"/>
             </div>
             <div className="BannerContent singleHeading">
                 <div className="headingBannerM container customCampaignContainer text-left ">
                    <div className="row">
                        <div className=" col-lg-12 col-xs-12 col-md-12 col-sm-12 text-center"> 
                        <h1>Vantage Fit FAQ Section</h1>
                        <p className="colorwhite">Have any doubts or queries? Our rich FAQ section will answer all your questions and help you understand Vantage Fit better. </p>
                        
                        </div>
                        
                    </div>
                </div>
             </div>

           
        </section> */}
                <section className="sectionSpacing pt-5 mt-5 faqN ">
                    <div className="container customCampaignContainer">
                        <div className="row">
                            {/* <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center ">
                                <div className="sprite faqpricing featuressprite hidden-xs hidden-sm"></div>
                            </div> */}
                        </div>
                        <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div className="mainHeadingN text-center my-2" style={{ fontSize: '2.9rem', fontWeight: 'bold', textAlign: 'center', lineHeight: '3.1rem' }}>Frequently Asked Questions</div>
                        </div>
                    </div>
                    <div className="container customCampaignContainer innerspace sponsor">
                        <div className="row">
                            <div className="col-xl-12 col-md-10 col-xs-12 col-sm-12 mx-auto ">
                                <div id="accordion" className="">
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq1" className='faqTitle'>
                                          &nbsp;I am not looking for a Year-round wellness initiative in particular, I want to run it only for a Few weeks/months in a year. Is that supported?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq1">
                                            <CardBody className='sponsorFAQpara'>
                                                Absolutely, We have a One time subscription plan which allows you to do just that. If you have more than 1000 users, you can also ask for a custom Price Quote. Click <a href="https://go.vantagefit.io/contact-us/" className="companycolor">here</a> to Talk to Sales.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq2" className='faqTitle'>
                                            &nbsp;What are the kind of challenges that I can run?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq2">
                                            <CardBody className='sponsorFAQpara'>
                                                <p className='sponsorFAQpara'>You can run challenges which revolves around a single type of activity and you can run challenges which have tasks of varying activities.</p>
                                                <p className='sponsorFAQpara'>For single activity challenges, Steps and Distance are the supported metrics since these accurately tracked by the app.</p>
                                                <p className='sponsorFAQpara'>You can also have challenges which do not have a target instead have a race to finish line challenge.</p>
                                                <p className='sponsorFAQpara'><b>Here are the different supported formats.</b></p>
                                                <ul>
                                                    <li className='sponsorFAQpara'>Race to Finish line</li>
                                                    <li className='sponsorFAQpara'>Daily Step/Distance Target and Competing Leaderboard</li>
                                                    <li className='sponsorFAQpara'>Multiple Activities and Targets with Competing Leaderboard</li>
                                                </ul>
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq3" className='faqTitle'>
                                            &nbsp;How long can I run a challenge ?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq3">
                                            <CardBody>
                                                <p className='sponsorFAQpara'>You can run a challenge for any duration between 2 - 52 weeks.</p>
                                                <p className='sponsorFAQpara'>Although we do suggest to not run a challenge for longer than 12 weeks since it may become a bit monotonous for the end users, but we do support any duration longer than 2 weeks</p>
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>

                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq4" className='faqTitle'>
                                            &nbsp;What kind of fitness trackers are supported by Vantage Fit ?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq4">
                                            <CardBody className='sponsorFAQpara'>
                                                Vantage Fit supports almost all the wearables available in the industry via Integrating with Google Fit / Apple Health and correspondingly Fitbit, Garmin, Xiaomi Bands, Amazefit bands, Apple Watch and more.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq5" className='faqTitle'>
                                            &nbsp;Can people from various countries and timezones participate in a challenge?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq5">
                                            <CardBody className='sponsorFAQpara'>
                                                Yes, we support global challenges with multiple timezones and multiple currencies for redemption of prizes.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-4'>
                                        <Button id="faq6" className='faqTitle'>
                                            &nbsp;How many times can I avail the One time subscription plan?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq6">
                                            <CardBody className='sponsorFAQpara'>
                                                A single one time subscription can vary between 2-12 weeks, In one fiscal year we allow you to use the subscribe to the one time challenge as many times as you wish. But we strongly recommend moving to a Yearly subscription plan if you have to apply the one time challenge plan. We also provide discounts based on the size of your user base.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq7" className='faqTitle'>
                                            &nbsp;Can I use the Free plan before subscribing to a Paid plan to try out Vantage Fit?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq7">
                                            <CardBody className='sponsorFAQpara'>
                                                Absolutely, We have created the free plan so you can be sure and confident about Vantage Fit’s Capabilities.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq8" className='faqTitle'>
                                            &nbsp;What do I do once my free plan ends?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq8">
                                            <CardBody className='sponsorFAQpara'>
                                                If you wish to extend your free plan, and try one more challenge, please reach out to us at <a href="mailto:partner@vantagecircle.com" className='companycolor'>partner@vantagecircle.com</a>. If you wish to move to a paid plan (one time or a yearly subscription), click <a href="https://go.vantagefit.io/contact-us/" className="companycolor">here</a> to contact sales.
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq9" className='faqTitle'>
                                            &nbsp;I have a large workforce, But I want to implement this only for a group of people. Is that supported.

                                        </Button>
                                        <UncontrolledCollapse toggler="#faq9">
                                            <CardBody className='sponsorFAQpara'>
                                                <p className='sponsorFAQpara'>Yes, There are three ways to achieve this.</p>
                                                <p className='sponsorFAQpara'>You can either only enable registration for a selected group of people,or you can create a challenge which is applicable only to a selected Business Unit or Location or even Gender or a combination of these, For Example, If you wish to have a challenge for the Australian Girls Cycling Team, you can and finally, you can create a private challenge and send an invite link to only those people who you want to join.</p>
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq10" className='faqTitle'>
                                            &nbsp;What options do we have for reporting and analytics?
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq10">
                                            <CardBody className='sponsorFAQpara'>
                                                <p className='sponsorFAQpara'>In the Admin Dashboard that you will be provided (Not included in Free Plan), you can view Insights, summaries, analytics and reports on an organisational level and on a challenge level too.</p>
                                                <p className='sponsorFAQpara'>You can also manage challenges, teams and broadcast health tips from the same Admin Dashboard.</p>                                            
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                    <Card className='my-4 py-3 py-lg-4'>
                                        <Button id="faq11" className='faqTitle'>
                                            &nbsp;My question is not listed here.
                                        </Button>
                                        <UncontrolledCollapse toggler="#faq11">
                                            <CardBody className='sponsorFAQpara'>
                                                Please reach out to us at <a href="mailto:partner@vantagecircle.com" className="companycolor">partner@vantagecircle.com</a>                                            
                                            </CardBody>
                                        </UncontrolledCollapse>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        </>
    );
}

const renderSponsorFAQ = () => {
    if(typeof window !== "undefined"){
        let id = document.querySelector('#sponsorFAQ')
        if(id !== null){
            ReactDOM.render(<GCWFaq />, id)
        }
        
    }
}
setTimeout(renderSponsorFAQ, 100)

export default GCWFaq;